import React from 'react';
import cn from 'classnames';
import CounterBox from 'components/UI/CounterBox';
import Hint from 'components/UI/Hint';
import { useCountersHandlers } from '../../hooks';
import * as styles from './TagCounter.module.scss';

function TagCounter({ value, title, hint, onChangeCount, index }) {
  const { increment, decrement } = useCountersHandlers(onChangeCount);
  const labelId = `tag-counter-label-${index}`;

  return (
    <li className={cn(styles.item, styles.tag)}>
      <span className={styles.itemTitle} aria-labelledby={labelId}>
        {title}
        {hint && (
          <span>
            <Hint withIcon iconColor="white" content={hint} hintInsideModal />
          </span>
        )}
      </span>
      <CounterBox
        theme="rightSide"
        value={value}
        increment={() => increment(title, value)}
        decrement={() => decrement(title, value)}
        labelId={labelId}
      />
    </li>
  );
}

export default React.memo(TagCounter);
